var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#F3F6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.125 25.5H26.875C25.781 25.5 24.7318 25.9346 23.9582 26.7082C23.1846 27.4818 22.75 28.531 22.75 29.625V43.375C22.75 44.469 23.1846 45.5182 23.9582 46.2918C24.7318 47.0654 25.781 47.5 26.875 47.5H46.125C47.219 47.5 48.2682 47.0654 49.0418 46.2918C49.8154 45.5182 50.25 44.469 50.25 43.375V29.625C50.25 28.531 49.8154 27.4818 49.0418 26.7082C48.2682 25.9346 47.219 25.5 46.125 25.5ZM46.125 28.25L37.1875 34.3963C36.9785 34.5169 36.7414 34.5805 36.5 34.5805C36.2586 34.5805 36.0215 34.5169 35.8125 34.3963L26.875 28.25H46.125Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.84c93bf3b7a3a8d6d098c5385eac244d.svg";
export { ForwardRef as ReactComponent };